import { TellescopeModelFromName } from "@tellescope/tanstack-query";

export const canCloseTicket = (ticket: TellescopeModelFromName<"tickets">): boolean => {
  if (!ticket.actions?.length) return true;

  return ticket.actions.every(
    (action) => !!action.completedAt || !!action.optional || action.type === "Create Prescription"
  );
};
